// components/Headers/DashboardHeader.jsx
import useAuth from "hooks/useAuth";

const Header = () => {
  const { auth } = useAuth();
  const email = auth?.user?.username || "Admin";
  const firstName = email.split("@")[0];

  const getGreeting = () => {
    const h = new Date().getHours();
    if (h < 12) return "Good morning,";
    if (h < 18) return "Good afternoon,";
    return "Good evening,";
  };

  const today = new Date().toLocaleDateString("en-US", {
    weekday: "long", year: "numeric", month: "long", day: "numeric",
  });

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=DM+Sans:wght@300;400;500&display=swap');

        .dh-bg {
          background: #0a0a1a;
          position: relative;
          padding: 2rem 1.5rem 3.8rem;
          overflow: hidden;
          /* flush with navbar — no top border-radius */
        }
        .dh-grid {
          position: absolute; inset: 0;
          background-image:
            linear-gradient(rgba(255,255,255,0.025) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.025) 1px, transparent 1px);
          background-size: 40px 40px;
          pointer-events: none;
        }
        .dh-orb1 {
          position: absolute; top: -80px; right: -60px;
          width: 260px; height: 260px; border-radius: 50%;
          background: radial-gradient(circle, rgba(83,74,183,0.28) 0%, transparent 70%);
          pointer-events: none;
        }
        .dh-orb2 {
          position: absolute; bottom: -40px; left: 8%;
          width: 180px; height: 180px; border-radius: 50%;
          background: radial-gradient(circle, rgba(29,158,117,0.15) 0%, transparent 70%);
          pointer-events: none;
        }
        .dh-inner { position: relative; z-index: 2; }

        .dh-eyebrow {
          font-size: 11px; letter-spacing: .1em; text-transform: uppercase;
          color: rgba(255,255,255,0.35); margin-bottom: 6px;
          display: flex; align-items: center; gap: 7px;
        }
        .dh-pulse {
          width: 5px; height: 5px; border-radius: 50%;
          background: #1D9E75; display: inline-block;
          animation: dhPulse 2s infinite;
        }
        @keyframes dhPulse { 0%,100%{opacity:1} 50%{opacity:.35} }

        .dh-greeting {
          font-size: 13px; color: rgba(255,255,255,0.38);
          font-weight: 300; margin-bottom: 4px;
          font-family: 'DM Sans', sans-serif;
        }
        .dh-name {
          font-family: 'Syne', sans-serif;
          font-size: clamp(1.6rem, 3vw, 2.2rem);
          font-weight: 800; color: #fff;
          letter-spacing: -0.03em; line-height: 1.05;
        }
        .dh-name span { color: #7F77DD; }

        .dh-date {
          font-size: 12px; color: rgba(255,255,255,0.3);
          margin-top: 8px; font-weight: 300;
          font-family: 'DM Sans', sans-serif;
        }

        .dh-wave {
          position: absolute; bottom: 0; left: 0;
          width: 100%; height: 50px; overflow: hidden;
        }
        .dh-wave svg { display: block; width: 100%; height: 100%; }
      `}</style>

      <div className="dh-bg pt-6">
        <div className="dh-grid" />
        <div className="dh-orb1" />
        <div className="dh-orb2" />

        <div className="dh-inner">
          <div className="dh-eyebrow">
            <span className="dh-pulse" />
            System admin · Platform overview
          </div>
          <div className="dh-greeting">{getGreeting()}</div>
          <div className="dh-name">
            Welcome back, <span>{firstName}</span>
          </div>
          <div className="dh-date">{today} · Let's make today count.</div>
        </div>

        <div className="dh-wave">
          <svg viewBox="0 0 1200 50" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
            <path
              d="M0,30 C300,55 600,5 900,30 C1050,42 1150,20 1200,28 L1200,50 L0,50 Z"
              fill="#f4f5f7"
            />
          </svg>
        </div>
      </div>
    </>
  );
};

export default Header;